module.exports = __webpack_public_path__ + "static/mid-b654bc6fa76b9a8e4d9459d5c0f1bb36.png";